import { render, staticRenderFns } from "./Earnings.vue?vue&type=template&id=bd180422&"
import script from "./Earnings.vue?vue&type=script&lang=js&"
export * from "./Earnings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports